import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import * as ReactBootstrap from 'react-bootstrap';
import { useAppContext } from '../../context/AppContext.js';
import Grid from '../../components/Grid.js';
import FiltersBar from '../../components/FiltersBar.js';
import PagingBar from '../../components/PagingBar.js';
import Title from '../../components/Title.js';
import Button from '../../components/Button.js';
import IconDownload from '../../components/icons/IconDownload.js';
import IconStatus from '../../components/icons/IconStatus.js';
import HomeBodyPart1ContextualAction1 from './HomeBodyPart1ContextualAction1.js';
import HomeBodyPart1ContextualAction2 from './HomeBodyPart1ContextualAction2.js';
import HomeBodyPart1ContextualAction3 from './HomeBodyPart1ContextualAction3.js';
import ApiService from '../../services/ApiService.js';
import SecurityService from '../../services/SecurityService.js';
import { getWords } from '../../utils/get-words.js';
import { protect } from '../../utils/protect.js';
import { download } from '../../utils/download.js';
import { isValid } from '../../utils/is-valid.js';

const HomeBodyPart1 = ReactRouterDOM.withRouter(function () {
  const { i18n, setError } = useAppContext();
  const words = getWords(i18n.code);
  const history = ReactRouterDOM.useHistory();
  const [count, setCount] = React.useState(null);
  const [pageNumber, setPageNumber] = React.useState(1);
  const pageSize = 10;
  const [filtersValues, setFiltersValues] = React.useState(() => {
    const savedFiltersValues = sessionStorage.getItem('filtersCapitals');
    console.log(savedFiltersValues);
    return savedFiltersValues ? JSON.parse(savedFiltersValues) : [null, null, null, null, null, null, null];
  });
  const [items, setItems] = React.useState([]);
  const [dataSourceBusinessUnitId, setDataSourceBusinessUnitId] = React.useState([]);
  const [dataSourceSubCategoryId, setDataSourceSubCategoryId] = React.useState([]);
  const [dataSourceSuperitemId, setDataSourceSuperitemId] = React.useState([]);
  const [dataSourceCurrencyId, setDataSourceCurrencyId] = React.useState([]);
  const [dataSourceBranchId, setDataSourceBranchId] = React.useState([]);
  const [dataSourceUserId, setDataSourceUserId] = React.useState([]);
  const [contextualAction, setContextualAction] = React.useState(null);
  const [contextualActionData, setContextualActionData] = React.useState(null);
  const [contextualActionPath, setContextualActionPath] = React.useState(null);
  const [contextualActionBody, setContextualActionBody] = React.useState(null);
  const [contextualActionValidated, setContextualActionValidated] = React.useState(null);
  const bodyRefContextualAction0 = React.useRef(null);
  const bodyRefContextualAction1 = React.useRef(null);
  const bodyRefContextualAction2 = React.useRef(null);

  React.useEffect(() => {
    fetchDataSourceBusinessUnitId();
    fetchDataSourceSubCategoryId();
    fetchDataSourceSuperitemId();
    fetchDataSourceCurrencyId();
    fetchDataSourceBranchId();
    fetchDataSourceUserId();
  }, []);

  React.useEffect(() => {
    setPageNumber(1);
    loadCount();
  }, [filtersValues]);

  React.useEffect(() => {
    loadRecords();
  }, [pageNumber, filtersValues]);

  const fetchDataSourceBusinessUnitId = async function () {
    let records = null;
    try {
      records = await ApiService.getBusinessUnits(null);
    }
    catch (error) {
      setError(error);
      return;
    }
    setDataSourceBusinessUnitId(
      records.map((record) => [record.businessUnitId, record.name])
    );
  }
  
  const fetchDataSourceSubCategoryId = async function () {
    let records = null;
    try {
      records = await ApiService.getSubCategories(null);
    }
    catch (error) {
      setError(error);
      return;
    }
    setDataSourceSubCategoryId(
      records.map((record) => [record.subCategoryId, record.name])
    );
  }
  
  const fetchDataSourceSuperitemId = async function () {
    let records = null;
    try {
      records = await ApiService.getSuperitems(null);
    }
    catch (error) {
      setError(error);
      return;
    }
    setDataSourceSuperitemId(
      records.map((record) => [record.superitemId, record.name])
    );
  }
  
  const fetchDataSourceCurrencyId = async function () {
    let records = null;
    try {
      records = await ApiService.getCurrencies(null);
    }
    catch (error) {
      setError(error);
      return;
    }
    setDataSourceCurrencyId(
      records.map((record) => [record.currencyId, record.name])
    );
  }
  
  const fetchDataSourceBranchId = async function () {
    let records = null;
    try {
      records = await ApiService.getBranches(null);
    }
    catch (error) {
      setError(error);
      return;
    }
    setDataSourceBranchId(
      records.map((record) => [record.branchId, record.name])
    );
  }
  
  const fetchDataSourceUserId = async function () {
    let records = null;
    try {
      records = await ApiService.getUsers(null);
    }
    catch (error) {
      setError(error);
      return;
    }
    setDataSourceUserId(
      records.map((record) => [record.userId, protect(function ([firstName, lastName]) { return `${firstName} ${lastName}` }, [ record.firstName, record.lastName ])])
    );
  }
  
  const loadCount = async function () {
    try {
      const args = {};
      if (filtersValues[0] !== null && filtersValues[0] !== undefined) {
        args.businessUnitIds = filtersValues[0].join(',');
      }
      if (filtersValues[1] !== null && filtersValues[1] !== undefined) {
        args.subCategoryIds = filtersValues[1].join(',');
      }
      if (filtersValues[2] !== null && filtersValues[2] !== undefined) {
        args.superitemIds = filtersValues[2].join(',');
      }
      if (filtersValues[3] !== null && filtersValues[3] !== undefined) {
        args.currencyIds = filtersValues[3].join(',');
      }
      if (filtersValues[4] !== null && filtersValues[4] !== undefined) {
        args.branchIds = filtersValues[4].join(',');
      }
      if (filtersValues[5] !== null && filtersValues[5] !== undefined) {
        args.userIds = filtersValues[5].join(',');
      }
      if (filtersValues[6] !== null && filtersValues[6] !== undefined) {
        args.statuss = filtersValues[6].join(',');
      }
      setCount(await ApiService.getCountBudgetCapitals(args));
    }
    catch (error) {
      setError(error);
      return;
    }
  }
  
  const loadRecords = async function () {
    let records = null;
    try {
      const args = {};
      if (filtersValues[0] !== null && filtersValues[0] !== undefined) {
        args.businessUnitIds = filtersValues[0].join(',');
      }
      if (filtersValues[1] !== null && filtersValues[1] !== undefined) {
        args.subCategoryIds = filtersValues[1].join(',');
      }
      if (filtersValues[2] !== null && filtersValues[2] !== undefined) {
        args.superitemIds = filtersValues[2].join(',');
      }
      if (filtersValues[3] !== null && filtersValues[3] !== undefined) {
        args.currencyIds = filtersValues[3].join(',');
      }
      if (filtersValues[4] !== null && filtersValues[4] !== undefined) {
        args.branchIds = filtersValues[4].join(',');
      }
      if (filtersValues[5] !== null && filtersValues[5] !== undefined) {
        args.userIds = filtersValues[5].join(',');
      }
      if (filtersValues[6] !== null && filtersValues[6] !== undefined) {
        args.statuss = filtersValues[6].join(',');
      }
      args.offset = (pageNumber - 1) * pageSize;
      args.limit = pageSize;
      records = await ApiService.getBudgetCapitals(args);
    }
    catch (error) {
      setError(error);
      return;
    }
    setItems(records.map((record, index) => ({
      key: record.budgetCapitalId,
      data: [
        record.businessUnitName,
        record.businessUnitCode,
        record.subCategoryName,
        record.subCategoryCode,
        record.superitemName,
        record.superitemCode,
        record.currencyName,
        record.currencyCode,
        record.branchName,
        record.branchCode,
        protect(function ([firstName, lastName]) { return `${firstName} ${lastName}` }, [ record.userFirstName, record.userLastName ]),
        record.userUsername,
        record.status,
        protect(function ([amount]) { return amount / 1000; }, [ record.janAmount ]),
        protect(function ([amount]) { return amount / 1000; }, [ record.febAmount ]),
        protect(function ([amount]) { return amount / 1000; }, [ record.marAmount ]),
        protect(function ([amount]) { return amount / 1000; }, [ record.aprAmount ]),
        protect(function ([amount]) { return amount / 1000; }, [ record.mayAmount ]),
        protect(function ([amount]) { return amount / 1000; }, [ record.junAmount ]),
        protect(function ([amount]) { return amount / 1000; }, [ record.julAmount ]),
        protect(function ([amount]) { return amount / 1000; }, [ record.augAmount ]),
        protect(function ([amount]) { return amount / 1000; }, [ record.sepAmount ]),
        protect(function ([amount]) { return amount / 1000; }, [ record.octAmount ]),
        protect(function ([amount]) { return amount / 1000; }, [ record.novAmount ]),
        protect(function ([amount]) { return amount / 1000; }, [ record.decAmount ]),
      ],
      record: record
    })));
  }
  
  const exportRecords = async function () {
    let data = null;
    try {
      const args = {};
      if (filtersValues[0] !== null && filtersValues[0] !== undefined) {
        args.businessUnitIds = filtersValues[0].join(',');
      }
      if (filtersValues[1] !== null && filtersValues[1] !== undefined) {
        args.subCategoryIds = filtersValues[1].join(',');
      }
      if (filtersValues[2] !== null && filtersValues[2] !== undefined) {
        args.superitemIds = filtersValues[2].join(',');
      }
      if (filtersValues[3] !== null && filtersValues[3] !== undefined) {
        args.currencyIds = filtersValues[3].join(',');
      }
      if (filtersValues[4] !== null && filtersValues[4] !== undefined) {
        args.branchIds = filtersValues[4].join(',');
      }
      if (filtersValues[5] !== null && filtersValues[5] !== undefined) {
        args.userIds = filtersValues[5].join(',');
      }
      if (filtersValues[6] !== null && filtersValues[6] !== undefined) {
        args.statuss = filtersValues[6].join(',');
      }
      data = await ApiService.getBudgetCapitalsExport(args);
    }
    catch (error) {
      setError(error);
      return;
    }
    download('Export.csv', data);
  }
  
  const refreshMe = async function () {
    await loadCount();
    await loadRecords();
  }
  
  const handleClickItem = async function (e, item) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    history.push('/budget-capital/' + item.record.budgetCapitalId);
  }
  
  const handleContextualAction0 = async function (e, item) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    let budgetCapital = null;
    try {
      budgetCapital = await ApiService.getBudgetCapital(item.record.budgetCapitalId);
    }
    catch (error) {
      setError(error);
      return;
    }
    setContextualAction({ index: 0, budgetCapital: budgetCapital });
    const path = {};
    path.budgetCapitalId = budgetCapital.budgetCapitalId;
    setContextualActionPath(path);
  }
  const submitContextualAction0 = async function (e) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    if (isValid(bodyRefContextualAction0.current)) {
      try {
        await ApiService.putBudgetCapitalSetInRevision(contextualActionPath.budgetCapitalId, contextualActionBody);
      }
      catch (error) {
        setError(error);
        return;
      }
      setContextualAction(null);
      setContextualActionPath(null);
      setContextualActionValidated(null);
      refreshMe();
    }
    else {
      setContextualActionValidated(true);
    }
  }
  const handleContextualAction1 = async function (e, item) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    let budgetCapital = null;
    try {
      budgetCapital = await ApiService.getBudgetCapital(item.record.budgetCapitalId);
    }
    catch (error) {
      setError(error);
      return;
    }
    setContextualAction({ index: 1, budgetCapital: budgetCapital });
    const path = {};
    path.budgetCapitalId = budgetCapital.budgetCapitalId;
    setContextualActionPath(path);
  }
  const submitContextualAction1 = async function (e) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    if (isValid(bodyRefContextualAction1.current)) {
      try {
        await ApiService.putBudgetCapitalSetConfirmed(contextualActionPath.budgetCapitalId, contextualActionBody);
      }
      catch (error) {
        setError(error);
        return;
      }
      setContextualAction(null);
      setContextualActionPath(null);
      setContextualActionValidated(null);
      refreshMe();
    }
    else {
      setContextualActionValidated(true);
    }
  }
  const handleContextualAction2 = async function (e, item) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    let budgetCapital = null;
    try {
      budgetCapital = await ApiService.getBudgetCapital(item.record.budgetCapitalId);
    }
    catch (error) {
      setError(error);
      return;
    }
    setContextualAction({ index: 2, budgetCapital: budgetCapital });
    const path = {};
    path.budgetCapitalId = budgetCapital.budgetCapitalId;
    setContextualActionPath(path);
  }
  const submitContextualAction2 = async function (e) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    if (isValid(bodyRefContextualAction2.current)) {
      try {
        await ApiService.putBudgetCapitalSetSent(contextualActionPath.budgetCapitalId, contextualActionBody);
      }
      catch (error) {
        setError(error);
        return;
      }
      setContextualAction(null);
      setContextualActionPath(null);
      setContextualActionValidated(null);
      refreshMe();
    }
    else {
      setContextualActionValidated(true);
    }
  }
  const updateContextualActionData = function (field, value) {
    setContextualActionData({ ...contextualActionData, [field]: value });
  }
  const updateContextualActionPath = function (field, value) {
    setContextualActionPath({ ...contextualActionPath, [field]: value });
  }
  const updateContextualActionBody = function (field, value) {
    setContextualActionBody({ ...contextualActionBody, [field]: value });
  }
  const cancelContextualAction = async function (e) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    setContextualAction(null);
    setContextualActionData(null);
    setContextualActionValidated(null);
  }
  
  return (
    <div>
      <div>
        <div className="d-flex align-items-center">
        <div className="pe-3">
          <div className="p-1 rounded text-black hov-black cursor-pointer" onClick={(e) => exportRecords(e)}>
            <IconDownload size="sm" />
          </div>
        </div>
          <FiltersBar
            sessionStorageKey="filtersCapitals"
            filters={[
              {
                label: words.businessUnitShort,
                variant: 'option',
                dataSource: dataSourceBusinessUnitId
              },
              {
                label: words.subCategory,
                variant: 'option',
                dataSource: dataSourceSubCategoryId
              },
              {
                label: words.superitem,
                variant: 'option',
                dataSource: dataSourceSuperitemId
              },
              {
                label: words.currency,
                variant: 'option',
                dataSource: dataSourceCurrencyId
              },
              {
                label: words.branch,
                variant: 'option',
                dataSource: dataSourceBranchId
              },
              {
                label: words.officer,
                variant: 'option',
                dataSource: dataSourceUserId
              },
              {
                label: words.status,
                variant: 'option',
                dataSource: [['inRevision', words.inRevision], ['confirmed', words.confirmed], ['sent', words.sent]]
              },
            ]}
            filtersValues={filtersValues}
            setFiltersValues={setFiltersValues}
          />
          <div className="flex-grow-1" />
        </div>
        <Grid
          contextualActions={[
            { icon: IconStatus, label: words.moveToRevision, color: 'red', onClick: handleContextualAction0, hidden: function (item) { return !(protect(function ([status]) { return status === 'confirmed' }, [ item.record.status ]) && (SecurityService.hasRole('administrator'))) } },
            { icon: IconStatus, label: words.confirmAmounts, color: 'yellow', onClick: handleContextualAction1, hidden: function (item) { return !(protect(function ([status]) { return status === 'inRevision' }, [ item.record.status ]) && (SecurityService.hasRole('officer'))) } },
            { icon: IconStatus, label: words.sendAmounts, color: 'green', onClick: handleContextualAction2, hidden: function (item) { return !(protect(function ([status]) { return status === 'confirmed' }, [ item.record.status ]) && (SecurityService.hasRole('administrator'))) } },
          ]}
          fields={[
            {
              label: words.businessUnitShort,
              type: 'string',
              bindIndex: 0,
              secondaryField: {
                type: 'string',
                bindIndex: 1,
              },
            },
            {
              label: words.subCategory,
              type: 'string',
              bindIndex: 2,
              secondaryField: {
                type: 'string',
                bindIndex: 3,
              },
            },
            {
              label: words.superitem,
              type: 'string',
              bindIndex: 4,
              secondaryField: {
                type: 'string',
                bindIndex: 5,
              },
            },
            {
              label: words.currency,
              type: 'string',
              bindIndex: 6,
              secondaryField: {
                type: 'string',
                bindIndex: 7,
              },
            },
            {
              label: words.branch,
              type: 'string',
              bindIndex: 8,
              secondaryField: {
                type: 'string',
                bindIndex: 9,
              },
            },
            {
              label: words.officer,
              type: 'string',
              bindIndex: 10,
              secondaryField: {
                type: 'string',
                bindIndex: 11,
              },
            },
            {
              label: words.status,
              type: 'string',
              translate: true,
              variant: 'framed-text',
              color: function (value) { return value === 'inRevision' ? 'red' : (value === 'confirmed' ? 'yellow' : (value === 'sent' ? 'green' : 'black')); },
              alignment: 'center',
              bindIndex: 12,
            },
            {
              label: words.jan,
              alignment: 'right',
              paragraph: {
                template: words.millionCount,
                fields: [
                  {
                    type: 'integer',
                    bindIndex: 13,
                  },
                ]
              },
            },
            {
              label: words.feb,
              alignment: 'right',
              paragraph: {
                template: words.millionCount,
                fields: [
                  {
                    type: 'integer',
                    bindIndex: 14,
                  },
                ]
              },
            },
            {
              label: words.mar,
              alignment: 'right',
              paragraph: {
                template: words.millionCount,
                fields: [
                  {
                    type: 'integer',
                    bindIndex: 15,
                  },
                ]
              },
            },
            {
              label: words.apr,
              alignment: 'right',
              paragraph: {
                template: words.millionCount,
                fields: [
                  {
                    type: 'integer',
                    bindIndex: 16,
                  },
                ]
              },
            },
            {
              label: words.may,
              alignment: 'right',
              paragraph: {
                template: words.millionCount,
                fields: [
                  {
                    type: 'integer',
                    bindIndex: 17,
                  },
                ]
              },
            },
            {
              label: words.jun,
              alignment: 'right',
              paragraph: {
                template: words.millionCount,
                fields: [
                  {
                    type: 'integer',
                    bindIndex: 18,
                  },
                ]
              },
            },
            {
              label: words.jul,
              alignment: 'right',
              paragraph: {
                template: words.millionCount,
                fields: [
                  {
                    type: 'integer',
                    bindIndex: 19,
                  },
                ]
              },
            },
            {
              label: words.aug,
              alignment: 'right',
              paragraph: {
                template: words.millionCount,
                fields: [
                  {
                    type: 'integer',
                    bindIndex: 20,
                  },
                ]
              },
            },
            {
              label: words.sep,
              alignment: 'right',
              paragraph: {
                template: words.millionCount,
                fields: [
                  {
                    type: 'integer',
                    bindIndex: 21,
                  },
                ]
              },
            },
            {
              label: words.oct,
              alignment: 'right',
              paragraph: {
                template: words.millionCount,
                fields: [
                  {
                    type: 'integer',
                    bindIndex: 22,
                  },
                ]
              },
            },
            {
              label: words.nov,
              alignment: 'right',
              paragraph: {
                template: words.millionCount,
                fields: [
                  {
                    type: 'integer',
                    bindIndex: 23,
                  },
                ]
              },
            },
            {
              label: words.dec,
              alignment: 'right',
              paragraph: {
                template: words.millionCount,
                fields: [
                  {
                    type: 'integer',
                    bindIndex: 24,
                  },
                ]
              },
            },
          ]}
          onClickItem={(SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) ? handleClickItem : null}
          items={items}
        />
        {count !== null && count !== undefined ?
          <PagingBar
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            countOfItems={count}
            countOfPages={Math.ceil(count/pageSize)}
          /> :
          null
        }
      </div>
      {contextualAction && contextualAction.index === 0 ?
        <ReactBootstrap.Modal
          show={true}
          onHide={() => cancelContextualAction({})}
          scrollable={true}
          centered={true}
         
        >
          <ReactBootstrap.Modal.Header className="pt-2 pb-1 ps-2 pe-3" closeButton={true}>
            <Title level={1} icon={IconStatus} color="red" label={words.moveToRevision} />
          </ReactBootstrap.Modal.Header>
          <ReactBootstrap.Modal.Body ref={bodyRefContextualAction0} className="p-0">
            <div className="p-2">
              <HomeBodyPart1ContextualAction1 budgetCapital={contextualAction ? contextualAction.budgetCapital : null} />
            </div>
          </ReactBootstrap.Modal.Body>
          <ReactBootstrap.Modal.Footer className="p-2">
            <div>
              <Button label={words.yes} color="red" onClick={submitContextualAction0} />
            </div>
            <div>
              <Button label={words.no} color="blue" onClick={cancelContextualAction} />
            </div>
          </ReactBootstrap.Modal.Footer>
        </ReactBootstrap.Modal> :
        null
      }
      {contextualAction && contextualAction.index === 1 ?
        <ReactBootstrap.Modal
          show={true}
          onHide={() => cancelContextualAction({})}
          scrollable={true}
          centered={true}
         
        >
          <ReactBootstrap.Modal.Header className="pt-2 pb-1 ps-2 pe-3" closeButton={true}>
            <Title level={1} icon={IconStatus} color="gold" label={words.confirmAmounts} />
          </ReactBootstrap.Modal.Header>
          <ReactBootstrap.Modal.Body ref={bodyRefContextualAction1} className="p-0">
            <div className="p-2">
              <HomeBodyPart1ContextualAction2 budgetCapital={contextualAction ? contextualAction.budgetCapital : null} />
            </div>
          </ReactBootstrap.Modal.Body>
          <ReactBootstrap.Modal.Footer className="p-2">
            <div>
              <Button label={words.yes} color="gold" onClick={submitContextualAction1} />
            </div>
            <div>
              <Button label={words.no} color="blue" onClick={cancelContextualAction} />
            </div>
          </ReactBootstrap.Modal.Footer>
        </ReactBootstrap.Modal> :
        null
      }
      {contextualAction && contextualAction.index === 2 ?
        <ReactBootstrap.Modal
          show={true}
          onHide={() => cancelContextualAction({})}
          scrollable={true}
          centered={true}
         
        >
          <ReactBootstrap.Modal.Header className="pt-2 pb-1 ps-2 pe-3" closeButton={true}>
            <Title level={1} icon={IconStatus} color="green" label={words.sendAmounts} />
          </ReactBootstrap.Modal.Header>
          <ReactBootstrap.Modal.Body ref={bodyRefContextualAction2} className="p-0">
            <div className="p-2">
              <HomeBodyPart1ContextualAction3 budgetCapital={contextualAction ? contextualAction.budgetCapital : null} />
            </div>
          </ReactBootstrap.Modal.Body>
          <ReactBootstrap.Modal.Footer className="p-2">
            <div>
              <Button label={words.yes} color="green" onClick={submitContextualAction2} />
            </div>
            <div>
              <Button label={words.no} color="blue" onClick={cancelContextualAction} />
            </div>
          </ReactBootstrap.Modal.Footer>
        </ReactBootstrap.Modal> :
        null
      }
    </div>
  );
})

export default HomeBodyPart1;
